export const FINANCE_FORECAST_API_BASE_URL = process.env.REACT_APP_FINANCE_FORECAST_API_BASE_URL;


// export const FINANCE_FORECAST_API_BASE_URL = 'http://localhost:5000/financial-forecasting/api'
export const FINANICAL_LEVERS = {
    TARGET: "Target (Revised)",
    SALES: "Sales",
    COGS: "COGS",
    DISCOUNT: "Discount",
    ADVERTISEMENT_COST: "Advertisement Cost",
    PROMOTION_DAYS: "Promotion Days"
}
  
export const LINE_CHART_LEVER_NAME = {
    REVENUE: "Revenue",
    SALES: "Sales",
    COGS: "COGS"
}